export default "/react/logoPostmypost-9af8e42c.png";